import styled from 'styled-components'

import { Banner, Button } from '@sketch/components'
import { ContinueWithApple, ContinueWithGoogle } from '@sketch/modules-common'

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
`

export const Warning = styled.strong`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.state.negative.A};
`

export const StyledBanner = styled(Banner)`
  padding: 16px;
  margin: 8px 0 24px 0;
  font-size: ${({ theme }) => theme.fontSizes.C};
  text-align: center;

  ${Warning} {
    margin-top: 16px;
    display: block;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
  }
`

export const CancelButton = styled(Button)`
  max-width: 70px;
`

export const StyledAppleButton = styled(ContinueWithApple)`
  padding: 10px 20px; /* stylelint-disable-line scales/space */
`

export const StyledGoogleButton = styled(ContinueWithGoogle)`
  padding: 10px 20px; /* stylelint-disable-line scales/space */
`
